/**
 * API function to get unsigned transaction CBOR for depositing to a fund
 */

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

export interface DepositRequestBody {
  fund_id: string;
  user_address: string;
  multiple: number;
}

export interface DepositResponse {
  cbor: string;
}

export async function depositToFund(
  fundId: string,
  userAddress: string,
  multiple: number
): Promise<string> {
  // Address goes in query parameter, rest in body
  const url = `${API_URL}/deposit?address=${encodeURIComponent(userAddress)}`;

  const requestBody: DepositRequestBody = {
    fund_id: fundId,
    user_address: userAddress,
    multiple: multiple,
  };

  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    let message = `Deposit API error: ${response.status}`;
    try {
      const errorBody = await response.json();
      if (errorBody.detail) message = errorBody.detail;
    } catch {}
    throw new Error(message);
  }

  const data: DepositResponse = await response.json();
  return data.cbor;
}
